module.exports = __webpack_public_path__ + "static/media/p60p.737856d1.jpg";